module.exports = __webpack_public_path__ + "img/01-logo-transparent.de59880d.webp";